export function exportToCsv(filename: string, rows: object[]) {
  if (!filename || typeof filename !== 'string') {
    throw new Error('Filename must be a non-empty string');
  }
  if (!Array.isArray(rows) || !rows.length) return;

  const replacer = (key: string, value: any) =>
    value === null || value === undefined ? '' : value;
  const header = Object.keys(rows[0]);
  const csv = [
    header.join(','),
    ...rows.map(row =>
      header
        .map((fieldName: string) => JSON.stringify(row[fieldName as keyof typeof row], replacer))
        .join(',')
    ),
  ].join('\r\n');

  const blob = new Blob([csv], { type: 'text/csv' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = filename;
  try {
    link.click();
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 100);
  }
}
